import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 25px",
    cursor: "none !important",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1250)]: {
      margin: "0 1rem",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1080)]: {
      margin: "0 25px",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 450)]: {
      margin: "0 1rem",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 400)]: {
      margin: "0 10px",
    },
    "&:hover": {
      "& p": {
        opacity: 0.9,
      },
      "& img": {
        opacity: 0.9,
      },
    },
  },
  image: {
    width: "50px",
    height: "50px",
    opacity: 0.5,
    transition: "all 0.3s",
  },
  imgActive: {
    opacity: 1,
    transform: "scale(1.2)",
  },
  p: {
    cursor: "none !important",
    margin: 0,
    fontFamily: "Montserrat",
    color: "white",
    width: "calc(100% + 20px)",
    textAlign: "center",
    letterSpacing: "0.02em",
    opacity: 0.5,
    fontSize: "12px",
    fontWeight: "700",
    marginTop: "15px",
    textTransform: "uppercase",
    transition: "all 0.3s",
    lineHeight: "1rem",
    borderBottom: "0px solid #FFC636",
  },
  pActive: {
    cursor: "none !important",
    opacity: 1,
    transform: "scale(1.2)",
    lineHeight: "18.2px",
    borderBottom: "2px solid #FFC636",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 400)]: {
      transform: "scale(1.1)",
    },
  },
});

const useStyles = makeStyles(styles);

export default function ColorTicket({
  active,
  img,
  name,
  handleChange,
  index,
}) {
  const classes = useStyles();
  return (
    <div onClick={() => handleChange(index)} className={classes.root}>
      <img
        className={clsx(classes.image, active && classes.imgActive)}
        src={img}
        alt={name}
      />
      <p className={clsx(classes.p, active && classes.pActive)}>{name}</p>
    </div>
  );
}
